import script from "./LiteracyTestFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteracyTestFormView.vue?vue&type=script&setup=true&lang=js"

import "./LiteracyTestFormView.vue?vue&type=style&index=0&id=5a3fdd24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3fdd24"]])

export default __exports__